import { getIncrementalArray } from 'helpers/array';
import { BEMBlock } from 'helpers/classnames';
import { Button } from 'palette/Button';
import { OnChangeEvent } from 'palette/Types/events';
import { getSEOLink } from './helpers';
import { useDropdown } from './hooks/use-dropdown';
import './styles/Dropdown.scss';

interface DropdownProps {
    currentPage: number;
    pageCount: number;
    isCustomStyle: boolean;
    label: string;
    onChange(id: number, event: OnChangeEvent): void;
    seoLink?: string;
}

export function Dropdown({
    onChange,
    currentPage,
    pageCount,
    isCustomStyle,
    label,
    seoLink,
}: DropdownProps) {
    const list = getIncrementalArray(pageCount);
    const {
        isVisible,
        handleChange,
        handleCustomListItemClick,
        handleToggleButtonClick,
    } = useDropdown({ isCustomStyle, onChange });

    const [block, BEMElement] = BEMBlock('palette-dropdown', { open: isVisible });

    return (
        <div className={block}>
            <Button
                iconName="palette_chevron_down"
                label={`${label} ${currentPage}/${pageCount}`}
                theme="secondary"
                onClick={handleToggleButtonClick}
            />
            {isCustomStyle && (
                <div className={BEMElement('list-container')}>
                    <ul className={BEMElement('list')}>
                        {list.map(index => (
                            <li
                                key={index}
                                className={BEMElement('list-item', { selected: index === currentPage })}
                                data-page={index}
                            >
                                <a
                                    className={BEMElement('list-item-link')}
                                    href={getSEOLink(index, seoLink)}
                                    onClick={e => handleCustomListItemClick(index, e)}
                                >
                                    { index }
                                </a>
                            </li>
                        ))}
                    </ul>
                </div>
            ) }
            <div className={BEMElement('select')}>
                <select
                    value={currentPage}
                    onChange={handleChange}
                >
                    {list.map(index => (
                        <option
                            key={index}
                            value={index}
                        >
                            {index}
                        </option>
                    ))}
                </select>
            </div>
        </div>
    );
}

export default null;
